import { render, staticRenderFns } from "./rejectedIncident.vue?vue&type=template&id=24a2d3bf&scoped=true"
import script from "./rejectedIncident.vue?vue&type=script&lang=js"
export * from "./rejectedIncident.vue?vue&type=script&lang=js"
import style0 from "./rejectedIncident.vue?vue&type=style&index=0&id=24a2d3bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a2d3bf",
  null
  
)

export default component.exports